'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudDownloadOutline = function IoIosCloudDownloadOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.6 29.8l4.3 4.2v-18.9h1.2v18.9l4.3-4.2 1 0.9-5.9 5.7-5.8-5.7z m16.1-17c3.5 0 6.3 2.9 6.3 6.4s-2.9 6.4-6.4 6.4h-7.9v-1.2h7.9c2.9 0 5.2-2.4 5.2-5.2s-2.3-5.2-5.2-5.2h-1.2v-1.6c0-4.3-3.6-7.6-7.9-7.6-2.9 0-5.7 1.8-7 4.4l-0.5 1.1-1.1-0.5c-0.4-0.3-1-0.4-1.5-0.4-1.7 0-3.2 1.4-3.5 3l0 0.7-0.7 0.3c-2.4 0.7-4 2.8-4 5.2 0 3.1 2.6 5.8 5.8 5.8h7.1v1.2h-7.1c-3.9 0-7-3.1-7-6.9 0-3.1 2-5.6 4.8-6.5 0.4-2.2 2.2-4 4.6-4 0.8 0 1.4 0.2 2 0.5 1.5-3.1 4.6-5.1 8.2-5.1 5 0 9.1 4 9.1 9 0 0.1 0 0.1 0 0.2z' })
        )
    );
};

exports.default = IoIosCloudDownloadOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloud-download-outline.js
// module id = 2601
// module chunks = 168707334958949